/**
 * Launch countdown helpers + the red-LED countdown clock.
 *
 * Shared by the homepage Starship panel/card and the dedicated /launches page
 * so the countdown math and markup live in exactly one place.
 */

import { Fragment } from 'react';


// Break a launch `net` ISO string into padded DDD:HH:MM:SS parts.
// Returns null when the time is missing, unparseable, or already past
// (callers render "LAUNCHED" for null).
export function countdownParts(net, nowMs) {
  if (!net) return null;
  const target = new Date(net).getTime();
  if (Number.isNaN(target)) return null;

  let secs = Math.floor((target - nowMs) / 1000);
  if (secs <= 0) return null;

  const dd = Math.floor(secs / 86400); secs -= dd * 86400;
  const hh = Math.floor(secs / 3600);  secs -= hh * 3600;
  const mm = Math.floor(secs / 60);    const ss = secs - mm * 60;

  const pad = (n) => String(n).padStart(2, '0');
  return { dd: pad(dd), hh: pad(hh), mm: pad(mm), ss: pad(ss) };
}

// Short monospace-friendly date for the upcoming list, e.g. "OCT 02".
export function shortDate(net) {
  if (!net) return '';
  const d = new Date(net);
  if (Number.isNaN(d.getTime())) return '';
  return d
    .toLocaleDateString('en-US', { month: 'short', day: '2-digit' })
    .toUpperCase();
}


// Each number sits above its own label in a centered column; the ":" separators
// are columns too (with an invisible label) so labels stay aligned under their
// numbers at any font size. cd === null → the launch has fired.
const SEGMENTS = [
  ['dd', 'days'],
  ['hh', 'hrs'],
  ['mm', 'min'],
  ['ss', 'sec'],
];

export default function CountdownClock({ cd }) {
  if (!cd) return <div className="hr-cd-launched">LAUNCHED</div>;

  return (
    <div className="hr-cd">
      {SEGMENTS.map(([key, label], i) => (
        <Fragment key={key}>
          {i > 0 && (
            <div className="hr-cd-group" aria-hidden="true">
              <span className="hr-cd-num hr-cd-sep">:</span>
              <span className="hr-cd-label">&nbsp;</span>
            </div>
          )}
          <div className="hr-cd-group">
            <span className="hr-cd-num">{cd[key]}</span>
            <span className="hr-cd-label">{label}</span>
          </div>
        </Fragment>
      ))}
    </div>
  );
}
